export const PartnerContactsTableHead = {
  cells: [{
    key: 'name',
    content: 'Name'
  }, {
    key: 'role',
    content: 'Role'
  }, {
    key: 'email',
    content: 'Email'
  }, {
    key: 'actions',
    content: 'Actions'
  }]
};